module.exports = {"TXTWCL_Popular_Bet_Builders":{"id":"TXTWCL_Popular_Bet_Builders","defaultMessage":"Popular Bet Builders"}}